import { px } from '@adsk/alloy-react-helpers';

import {
  AlloyLegacyThemeDesignTokens,
  CommentCardDesignTokens,
} from '../types';
import { WeaveTheme } from '../types/weaveTypes';

type WeaveTokens = NonNullable<WeaveTheme['tokens']>;

export const getCommentCardTokensAlloy = (
  theme: AlloyLegacyThemeDesignTokens,
): CommentCardDesignTokens => {
  const { typography, spacing, borderRadius } = theme;
  const { colors } = theme.tokens;
  const headerPadding = px(spacing.XS);
  const borderRadiusMedium = px(borderRadius.medium);

  return {
    container: {
      'background-color': colors.background.primary.value,
      'border-color': colors.border.subtle.value,
      'border-width': px(1),
      'border-style': 'solid',
      'border-radius': borderRadiusMedium,
    },
    header: {
      'background-color': colors.background.secondary.value,
      color: colors.text.primary.value,
      'padding-top': headerPadding,
      'padding-right': headerPadding,
      'padding-bottom': headerPadding,
      'padding-left': headerPadding,
      'font-family': typography.caption.fontFamily,
      'font-size': typography.caption.fontSize,
      'font-weight': typography.caption.fontWeight,
      'line-height': typography.caption.lineHeight,
      'border-top-left-radius': borderRadiusMedium,
      'border-top-right-radius': borderRadiusMedium,
    },
    username: {
      'margin-left': px(spacing.XXS),
    },
    body: {
      color: colors.text.primary.value,
      'padding-top': px(spacing.S),
      'padding-right': px(spacing.M),
      'padding-bottom': px(spacing.S),
      'padding-left': px(spacing.M),
      'font-family': typography.bodyMedium.fontFamily,
      'font-size': typography.bodyMedium.fontSize,
      'font-weight': typography.bodyMedium.fontWeight,
      'line-height': typography.bodyMedium.lineHeight,
      'word-break': 'break-word',
      'overflow-wrap': 'break-word',
    },
  };
};

export const getCommentCardTokensWeave = (
  tokens: WeaveTokens,
  fontFamily: string,
): CommentCardDesignTokens => {
  const semantic = tokens?.semantic;
  const generic = tokens?.generic;
  const typography = tokens?.component?.typography;

  const spacing4 = generic?.spacing?.[4];
  const spacing8 = generic?.spacing?.[8];
  const spacing12 = generic?.spacing?.[12];
  const spacing16 = generic?.spacing?.[16];
  const borderRadius = generic?.['border-radius']?.[4];

  return {
    container: {
      'background-color': semantic?.['background-color']?.surface?.[100],
      'border-color': semantic?.['border-color']?.divider?.light,
      'border-width': generic?.['border-width']?.[1],
      'border-style': 'solid',
      'border-radius': borderRadius,
    },
    header: {
      'background-color': semantic?.['background-color']?.group?.header,
      color: semantic?.['text-color']?.medium?.default,
      'padding-top': spacing8,
      'padding-right': spacing8,
      'padding-bottom': spacing8,
      'padding-left': spacing8,
      'font-family': fontFamily,
      'font-size': typography?.caption?.['font-size'],
      'font-weight': typography?.regular?.['font-weight'],
      'line-height': typography?.caption?.['line-height'],
      'border-top-left-radius': borderRadius,
      'border-top-right-radius': borderRadius,
    },
    username: {
      'margin-left': spacing4,
    },
    body: {
      color: semantic?.['text-color']?.medium?.default,
      'padding-top': spacing12,
      'padding-right': spacing16,
      'padding-bottom': spacing12,
      'padding-left': spacing16,
      'font-family': fontFamily,
      'font-size': typography?.body?.['font-size'],
      'font-weight': typography?.regular?.['font-weight'],
      'line-height': typography?.body?.['line-height'],
      'word-break': 'break-word',
      'overflow-wrap': 'break-word',
    },
  };
};
